export const initialRangeMenuOptions = {
  bright: 80,
};
